<template>
  <v-container class="py-8">
    <div class="d-flex justify-space-between flex-column flex-sm-row">
      <router-link
        class="d-flex align-center justify-sm-center differential"
        v-for="(item, key) in items"
        :key="key"
        :to="item.link"
        style="gap: 10px; flex: 1"
      >
        <div class="img">
          <img :src="item.img" width="64" height="64" />
        </div>
        <div class="description">
          <h3 class="primary--text">{{ item.title }}</h3>
          {{ item.subtitle }}
        </div>
      </router-link>
    </div>
  </v-container>
</template>

<script>
export default {
  computed: {
    items() {
      return this.$rest("differentials").list.map((item) => {
        item.img = this.files + item.img;
        return item;
      });
    },
  },
  beforeCreate() {
    this.$rest("differentials").get();
  },
};
</script>

<style lang="scss">
.differential {
  text-decoration: none;
  color: var(--v-text-base);
  h3 {
    font-weight: 900;
    font-size: 21px;
    line-height: 21px;
    padding: 0;
    margin: 0;
  }
  .description {
    color: var(--v-text-base);
  }
  @media (max-width: 600px) {
    padding: 10px 0;
    border-bottom: solid 1px #efefef;
  }
}
</style>
